import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c70e4356"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OAcordeaoProfissionais",
  "data-testid": "OAcordeaProfissionais"
}
const _hoisted_2 = { class: "OAcordeaoProfissionais__SelecionarProfissionais" }
const _hoisted_3 = { class: "OAcordeaoProfissionais__Profissionais p-input-filled field" }

import MultiSelect from "primevue/multiselect"
  import { ref } from "vue"
  import Button from "primevue/button"
  import { OMensagemAcordeao } from "@/components/Gerais"
  import { OTabelaAcordeaoProfissionais } from "@/components/Profissionais"
  import { IProfissionais } from "@/types/profissionais"
  import { EntidadeGenerica } from "@/types/gerais"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAcordeaoProfissionais',
  setup(__props) {

  const categoriasSelecionadas = ref<EntidadeGenerica[]>([])
  const profissionaisSelecionados = ref<IProfissionais[]>([])
  const profissionaisAdicionados = ref<IProfissionais[]>([])

  const adicionarProfissionaisSelecionados = () => {
    profissionaisAdicionados.value.push(...profissionaisSelecionados.value)
    profissionaisSelecionados.value = []
  }

  const indexAtivo = ref(1)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_unref(MultiSelect), {
          modelValue: categoriasSelecionadas.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((categoriasSelecionadas).value = $event)),
          filter: true,
          "option-label": "nome",
          options: [],
          placeholder: "categoria"
        }, null, 8, ["modelValue"]), [
          [_vShow, indexAtivo.value === 1]
        ]),
        _withDirectives(_createVNode(_unref(MultiSelect), {
          modelValue: profissionaisSelecionados.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profissionaisSelecionados).value = $event)),
          filter: true,
          "option-label": "nome",
          options: [],
          placeholder: "profissionais"
        }, null, 8, ["modelValue"]), [
          [_vShow, indexAtivo.value === 1]
        ])
      ]),
      _withDirectives(_createVNode(_unref(Button), {
        onClick: adicionarProfissionaisSelecionados,
        class: "OAcordeaoProfissionais__BotaoAdicionarSelecionados",
        label: "adicionar selecionados"
      }, null, 512), [
        [_vShow, indexAtivo.value === 1]
      ])
    ]),
    _withDirectives(_createVNode(_unref(OTabelaAcordeaoProfissionais), { profissionais: profissionaisAdicionados.value }, null, 8, ["profissionais"]), [
      [_vShow, indexAtivo.value === 1]
    ]),
    _withDirectives(_createVNode(_unref(OMensagemAcordeao), {
      icon: "pi pi-users",
      responsabilidade: "profissional"
    }, null, 512), [
      [_vShow, indexAtivo.value === 0]
    ])
  ]))
}
}

})